import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { selectAuthorized } from 'lib/helpers/selectors'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { setClientId } from 'store/SSE/sse.reducer'
import { selectSSEClientId } from 'store/SSE/sse.selectors'
import { IApiError } from 'services/Shared/shared.models'
import { initializeSSEInstance } from 'services/Shared/shared.services'

const useInitializeSSEClientId = (): UseQueryResult<string, IApiError> => {
  const dispatch = useAppDispatch()

  const authorized = useAppSelector(selectAuthorized)
  const sseClientId = useAppSelector(selectSSEClientId)

  const query = useQuery<string, IApiError>(
    ['initializeSSEClientId', authorized, sseClientId],
    () => initializeSSEInstance(),
    {
      enabled: authorized && !sseClientId,
      onSuccess: clientId => {
        dispatch(setClientId(clientId))
      },
      onError: () => console.log('Ocurrió un error al crear el cliente SSE'),
    }
  )

  return query
}

export default useInitializeSSEClientId
